import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import {
  CaSections,
  FACILITY_INFORMATION_SECTION_ID,
  SectionIds,
  SectionLabels,
} from "encamp-shared/src/hmbp/sections";

type Props = {
  value: string[];
  onChange: (next: string[]) => void;
  disabled?: boolean;
};

const ORDERED_SECTIONS: CaSections[] = [
  CaSections.FacilityInformation,
  CaSections.HazardousMaterialsInventory,
  CaSections.EmergencyResponseAndTrainingPlan,
  CaSections.UndergroundStorageTanks,
  CaSections.TieredPermitting,
  CaSections.RecyclableMaterialsReport,
  CaSections.RemoteWasteConsolidationSiteAnnualNotification,
  CaSections.HazardousWasteTankClosureCertification,
  CaSections.AbovegroundPetroleumStorageAct,
  CaSections.CaliforniaAccidentalReleaseProgram,
];

export function SectionSelector({ value, onChange, disabled }: Props) {
  const selected = new Set(value);
  selected.add(FACILITY_INFORMATION_SECTION_ID);

  const toggle = (id: string) => {
    const next = new Set(selected);
    if (next.has(id)) {
      next.delete(id);
    } else {
      next.add(id);
    }
    next.add(FACILITY_INFORMATION_SECTION_ID);
    onChange([...next].sort());
  };

  return (
    <Stack spacing={1}>
      <Typography variant="subtitle2">CERS sections to submit</Typography>
      <FormGroup>
        {ORDERED_SECTIONS.map((s) => {
          const id = SectionIds[s];
          const isFacilityInfo = id === FACILITY_INFORMATION_SECTION_ID;
          return (
            <FormControlLabel
              key={id}
              control={
                <Checkbox
                  checked={selected.has(id)}
                  disabled={disabled || isFacilityInfo}
                  onChange={() => toggle(id)}
                />
              }
              label={SectionLabels[s]}
            />
          );
        })}
      </FormGroup>
    </Stack>
  );
}
